mutation (
  $input: ProductInquiryInput!
) {
  sendProductInquiry(
    input: $input
  )
}
